<template>
  <div class="permission">
    <div class="permission-wrap">
      <img src="@/assets/img/no_permission.png" alt="" class="permission-wrap-img">
      <span  class="permission-wrap-text">您访问的当前页面暂无权限，请联系管理员开通权限</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'noPermission'
}
</script>

<style lang="scss" scoped>
.permission{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  &-wrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-img{
      width: 320px;
    }
    &-text{
      color: rgba(0, 0, 0, 0.3);
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: 500;
      margin-top: 10px;
    }
  }
}
</style>
